import { InAppBrowser } from "@ionic-native/in-app-browser";
import { IonCol, IonIcon, IonImg, IonLabel, IonToast, IonToggle } from "@ionic/react";
import { chevronBackOutline, chevronForwardOutline } from "ionicons/icons";
import React, { useState } from "react";
import { connect } from "react-redux";
import * as constants from "../../../constants";
import { COLLECTIONS, getDoc, updateDoc } from "../../../firebase";
import { updateUserSettings } from "../../../Store/Actions";
import { checkMediaQuery } from "../../../utils";
import "../../../global.scss";

const Settings: React.FC = (props: any) => {
  React.useEffect(() => {
    // setNotificationsDataToState();
  }, []);
  const [state, setState] = useState({
    remindersEnabled: false,
    notificationsEnabled: false,
  });
  const [toast, setToast] = useState({
    showToast: false,
    toastMessage: "",
  });

  const setNotificationsDataToState = async () => {
    const data: any = await getDoc(props.uid, COLLECTIONS.USERS);
    if (data.data.hasOwnProperty("settings")) {
      setState({
        ...data.data.settings,
      });
    }
  };

  const handleChange = async (key: any, event: any) => {
    event.preventDefault();
    const payload = {
      settings: { ...props.settings, [key]: event.target.checked },
    };
    await props.updateUserSettings(payload);
    await updateDoc(props.uid, payload, COLLECTIONS.USERS);
  };
  return (
    <>
      <IonCol className="middle_panle res_bg_color" size-md="6">
        <div className="personal_details_text manage_vehicle_layout">
          <div className="personal_details_div wholeApp">
            <div className="personal_details_div_child settings_header">
              <IonImg
                src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
                className="back_arrow"
                onClick={() => props.history.goBack()}
              />

              <IonLabel className="personal_details_labels" color="secondary">
                {constants.SETTINGS}
              </IonLabel>
              <div />
            </div>
          </div>
          <div>
            <div className="settings-heading-div">
              <IonLabel color="secondary" className="settings-heading">
                {constants.GENERAL_SETTINGS}
              </IonLabel>
            </div>
            <div className="settings-div">
              {[
                {
                  name: constants.REMINDERS,
                  key: "remindersEnabled",
                  value: props.settings.remindersEnabled,
                },
                {
                  name: constants.NOTIFICATIONS,
                  key: "notificationsEnabled",
                  value: props.settings.notificationsEnabled,
                },
              ].map((ele: any, index: any) => (
                <div className="settings-type-div" key={index}>
                  <IonLabel color="secondary" className="settings-name">
                    {ele.name}
                  </IonLabel>
                  <IonToggle
                    checked={ele.value}
                    color="primary"
                    onClick={(event: any) => {
                      handleChange(ele.key, event);
                    }}
                  >
                    {ele.name}
                  </IonToggle>
                </div>
              ))}
            </div>
          </div>
          <div className="help-and-support">
            <div className="settings-div">
              {[
                {
                  name: constants.HELP_AND_SUPPORT,
                  path: "/portal/help-and-support",
                },
                {
                  name: constants.ABOUT_AUTOROX, //ABOUT_VALUE_PLUS, // ABOUT_TSERV,
                  path: "",
                },
              ].map((ele, index): any => (
                <div
                  className="settings-type-div"
                  key={index}
                  onClick={() => {
                    if (index < 1) {
                      !!ele.path && props.history.push(ele.path);
                    } else {
                      if (window.cordova) {
                        const target = "_blank";
                        const options =
                          "location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
                        InAppBrowser.create(constants.ABOUT_US_TSERV_LINK, target, options);
                        return;
                      }
                      window.open(constants.ABOUT_US_TSERV_LINK);
                    }
                  }}
                >
                  <IonLabel color="secondary" className="settings-name">
                    {ele.name}
                  </IonLabel>
                  <IonIcon
                    icon={chevronForwardOutline}
                    className="next-page-button"
                    // className="mobile-icon"
                    color="tertiary"
                  />
                </div>
              ))}
            </div>
          </div>
          <IonToast
            isOpen={toast.showToast}
            onDidDismiss={() =>
              setToast({
                showToast: false,
                toastMessage: "",
              })
            }
            color="warning"
            position="top"
            message={toast.toastMessage}
            duration={2000}
          />
        </div>
      </IonCol>
    </>
  );
};
export default connect(({ auth }: any) => ({ ...auth }), {
  updateUserSettings,
})(Settings);
